import './main/main-module';
import './templates/module';

/**
 * @ngdoc object
 * @name picklists
 * @description
 *
 */
angular
    .module('festzelt-os.vouchers', [
        'festzelt-os.vouchers.main',
        'festzelt-os.vouchers.templates'
    ]);

require('./vouchers-routes');



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/vouchers-module.js